import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

const AuthLayout = () => {
  const { isAuthenticated } = useAuthStore();
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AuthLayout;
